import React, { Component } from 'react';
import { connect } from 'react-redux';

import ViewSectionElement from './ViewSectionElement';

import styles from './_styles/ViewSectionBlock.module.scss';

const allActionCreators = Object.assign({});

export class ViewSectionAttributeBlock extends Component {

	dataElements() {		
		if(!this.props.attributes || !this.props.product?.attributes) { return []; }

		const attributeTypes = {};
		for(const attr of this.props.attributes) {
			attributeTypes[attr.type.key] = attr.type;
		}

		const elements = [];
		for(const prodAttr of this.props.product.attributes) {
			elements.push({
				label: attributeTypes[prodAttr.attribute_type].name,
				value: prodAttr.name,
			});
		}
		return elements;
	}
	
	render() {

		const elements = this.dataElements();

		return <div className={`${styles.ViewSectionBlock}`}>
			<div className={styles.body}>
				{elements.length === 0
					?	<div className={styles.noData}>No attributes assigned</div>
					:	<>
							{elements.map((elemProps, i) => {
								return <div key={i} className={styles.elementWrapper}>
									<ViewSectionElement {...elemProps} />
								</div>
							})}
						</>
				}
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ViewSectionAttributeBlock);